import React from "react"
import { useUserPrompt } from "hooks/useUserPrompt"
import { DiscoveryJourneyModal } from "packages/membership/components/DiscoveryJourney/DiscoveryJourneyModal"

const VISIBILITY = {
  DISCOVERY_JOURNEY_MODAL: {
    prompt: "DISCOVERY_JOURNEY_MODAL",
    featureFlag: {
      name: "experiment-use-discovery-journey",
      requiredValue: "1",
    },
  },
}

export const UserPromptModal: React.FC = () => {
  const { shouldShowPrompt, markPromptAsSeen } = useUserPrompt()

  const showDiscoveryJourneyModal = shouldShowPrompt(
    VISIBILITY.DISCOVERY_JOURNEY_MODAL.prompt,
    VISIBILITY.DISCOVERY_JOURNEY_MODAL.featureFlag
  )

  if (showDiscoveryJourneyModal) {
    return (
      <DiscoveryJourneyModal
        data-testid="DiscoveryJourneyModal"
        isVisible
        setNextVisibility={(visible: boolean, next?: () => void) => {
          if (visible === false)
            markPromptAsSeen(VISIBILITY.DISCOVERY_JOURNEY_MODAL.prompt).finally(
              () => next?.()
            )
        }}
      />
    )
  }

  return null
}
